import { useGetRenewVisaDocumentList } from "@/api/services/main/renew-visa";
import { RENEW_VISA_FILTER } from "@/features/renew-visa/constants/renewVisaFilter";
import { toNumber } from "@/utils/number";

type UseGetRenewVisaCompleteAndWithdrawnAndRejectedQuantityReturn = {
  quantity: number;
};
export const useGetRenewVisaCompleteAndWithdrawnAndRejectedQuantity = (): UseGetRenewVisaCompleteAndWithdrawnAndRejectedQuantityReturn => {
  const { data } = useGetRenewVisaDocumentList({
    status: RENEW_VISA_FILTER.COMPLETE_AND_WITHDRAWN_AND_REJECTED.status,
  });

  return {
    quantity: toNumber(data?.pagination.total),
  };
};
